import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const SkillSOSLogo = ({ size = 'md', showText = true, clickable = true, className = '', variant = 'default' }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const sizeClasses = {
    sm: 'w-10 h-10',
    md: 'w-16 h-16',  
    lg: 'w-20 h-20',
    xl: 'w-28 h-28'
  };

  const textSizes = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl', 
    xl: 'text-3xl'
  };

  const handleClick = () => {
    if (clickable) {
      navigate('/');
    }
  };

  // Typography variants for brand testing
  const renderBrandText = () => {
    switch(variant) {
      case 'dot':
        // Option 1: Middle dot between Skill and SOS
        return (
          <span className={`font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent ${textSizes[size]}`}>
            Skill<span className="mx-1">·</span>SOS
          </span>
        );
      
      case 'yellow-sos':
        // Option 2: SOS in yellow (wrench color)
        return (
          <span className={`font-bold ${textSizes[size]}`}>
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Skill</span>
            <span className="text-yellow-500">SOS</span>
            <sup className="text-xs ml-0.5 text-gray-600">™</sup>
          </span>
        );
      
      case 'dot-yellow':
        // Option 3: Dot + Yellow SOS
        return (
          <span className={`font-bold ${textSizes[size]}`}>
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Skill</span>
            <span className="text-yellow-500 mx-1">·</span>
            <span className="text-yellow-500">SOS</span>
          </span>
        );
      
      default:
        // Original: SkillSOS (no changes)
        return (
          <span className={`font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent ${textSizes[size]}`}>
            SkillSOS
          </span>
        );
    }
  };

  return (
    <div 
      className={`flex items-center gap-3 ${clickable ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''} ${className}`}
      onClick={handleClick}
    >
      <div className={`${sizeClasses[size]} relative overflow-hidden`}>
        {/* SkillSOS Logo */}
        <img 
          src="/skillsos-logo.png"
          alt="SkillSOS Logo"
          className="w-full h-full object-contain"
        />
      </div>
      
      {showText && (
        <div className="flex flex-col">
          {renderBrandText()}
          {size !== 'sm' && (
            <span 
              className="text-xs -mt-1 text-gray-600"
            >
              {t('homeServices')}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export const SkillSOSIcon = ({ className = "w-6 h-6" }) => {
  return (
    <div className={className}>
      <SkillSOSLogo size="sm" showText={false} />
    </div>
  );
};